import { connect } from 'react-redux'
import { BREAK_SM } from '#/consts'
import Images from './Images'

const mapStateToProps = (state: TopHap.StoreState) => ({
  isBot: state.global.isBot,
  // on small screen (mobile), only first image is shown.
  firstShownCount: state.ui.viewport.width > BREAK_SM ? 2 : 1
})

export default connect(mapStateToProps, null)(Images)
